<template>
  <div class="item">
    <b-button
      block
      href="#"
      v-b-toggle="rotas.modulo"
      variant="custom"
      class="item__button">
      <v-icon scale="1.8"
        :name="rotas.icon"
        class="icons" />
      {{ rotas.label }}
    </b-button>

    <div @click="clicouItemMenuMethod">
      <b-collapse
        :id="rotas.modulo"
        accordion="my-accordion"
        role="tabpanel"
        class="item__menu">
        <b-button
          v-for="rota in rotas.rotas"
          :key="rota.name"
          block
          :to="{ name: rota.name }"
          class="item__menu__button">
          <v-icon
            scale="1.4"
            :name="rota.menu.icon"
            class="icons" />
          {{ rota.menu.label }}
        </b-button>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { BCollapse, BButton } from 'bootstrap-vue/es/components'

export default {
  name: 'BarraLateral',
  components: {
    BCollapse,
    BButton,
  },
  props: {
    rotas: {
      required: true,
    },
  },
  methods: {
    clicouItemMenuMethod() {
      this.$emit('clicouItemMenu');
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/colors.scss";

.item {
  width: 100%;

  &__button {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    padding: .4rem 0;

    text-align: start;
    color: $cor-fonte-escura;
  }

  &__menu {
    background-color: $cor-barralateral-escura;

    &__button {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: flex-start;
      margin: 0;
      padding: .4rem 0;
      color: $cor-fonte-escura;
      text-align: start;
      background-color: transparent;
      border: none;
      border-radius: 0;
      transition: all .5s;

      &:hover {
        background-color: $cor-barralateral-escura-2;
      }
    }
  }
}

.icons {
  width: 2.5rem;
}

</style>
